module.exports = __webpack_public_path__ + "img/gsb.7987cbe7.png";